module.exports = __webpack_public_path__ + "img/p3-p1-chuanjia.74170bb8.gif";